import { Dispatch } from 'react';
import { get, post, put, remove } from 'communication/httpClient';
import { IGenericObject } from 'types';
import {
  SET_PLUGROUP_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  CREATE_INITIATED,
  UPDATE_INITIATED,
  DELETE_INITIATED,
  PLUGROUP_DELETED,
  PLUGROUP_CREATED,
  PLUGROUP_UPDATED,
  CLEAN_PLUGROUP,
  SET_PLUGROUP,
  PLU_GROUP_SYNC,
} from './actionTypes';
import { IPLUGroupsAction, IPLUGroupsActions, IPLUGroupUpdate } from './types';
import { cleanObject } from 'utils/object';

export const initialActionsState = {
  loadPLUGroups: () => {},
  loadPLUGroup: () => {},
  savePLUGroup: () => {},
  deletePLUGroup: () => {},
  cleanPLUGroup: () => {},
};

export const getActions = (dispatch: Dispatch<IPLUGroupsAction>): IPLUGroupsActions => ({
  loadPLUGroups: async (params: IGenericObject) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/plu-groups`, { params: cleanObject(params) });

    if (data) {
      dispatch({
        type: SET_PLUGROUP_LIST,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadPLUGroup: async (id: string) => {
    dispatch({
      type: PLU_GROUP_SYNC,
    });
    const { data, error } = await get(`/api/plu-groups/${id}`);

    if (data) {
      dispatch({
        type: SET_PLUGROUP,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  savePLUGroup: async (pluGroup: IPLUGroupUpdate, isNew: boolean, onSuccess?: () => void) => {
    dispatch({
      type: isNew ? CREATE_INITIATED : UPDATE_INITIATED,
    });
    const handler = isNew ? post : put;
    const { groupData: { pluGroupId } = {} } = pluGroup;

    const url = `/api/plu-groups/${isNew ? '' : pluGroupId}`;
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    const formData = new FormData();
    formData.append('groupData', JSON.stringify(pluGroup.groupData));

    formData.append(
      'imageFile',
      pluGroup.imageFile ? pluGroup.imageFile : new Blob([], { type: 'image/png' })
    );

    const { error } = await handler(url, formData, config);

    if (!error) {
      dispatch({
        type: isNew ? PLUGROUP_CREATED : PLUGROUP_UPDATED,
      });
      if (onSuccess) onSuccess();
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  deletePLUGroup: async (id: string, callback?: () => void) => {
    dispatch({
      type: DELETE_INITIATED,
    });
    const { data, error } = await remove(`/api/plu-groups/${id}`);

    if (data || data === '') {
      dispatch({
        type: PLUGROUP_DELETED,
        payload: id,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  cleanPLUGroup: () => {
    dispatch({
      type: CLEAN_PLUGROUP,
    });
  },
});
